import { useMemo } from "react";
import { useGetExtractedFiles } from "../../../hooks";
import { useListSamples } from "../../../hooks";
import { SearchGridData } from "../../search/@types";
import { ExtractedFilesSample } from "../../samples/@types";
import {
  IExtractedFilesQueryParams,
  ISamplesQuery
} from "../../../hooks/@types";

const useSelectAllQueryHashes = (
  samplesQuery?: ISamplesQuery | undefined,
  extractedSampleQuery?: IExtractedFilesQueryParams | undefined
) => {
  const shouldFetchSamples = !!samplesQuery;
  const shouldFetchExtractedSamples = !!extractedSampleQuery;

  const { samples, isLoading: isLoadingSamplesList } =
    useListSamples(samplesQuery);

  const { extractedFileResults, isLoading: isLoadingExtractedFiles } =
    useGetExtractedFiles(extractedSampleQuery?.hash, extractedSampleQuery);

  const querySamples: SearchGridData | ExtractedFilesSample[] | undefined =
    useMemo(() => {
      if (shouldFetchSamples) {
        return samples;
      } else if (shouldFetchExtractedSamples) {
        return extractedFileResults?.map(item => item.sample);
      } else {
        return undefined;
      }
    }, [
      isLoadingSamplesList,
      shouldFetchSamples,
      shouldFetchExtractedSamples,
      isLoadingExtractedFiles
    ]);

  const shouldUseQueryHashes =
    shouldFetchSamples || shouldFetchExtractedSamples;

  const subscribeQueryHashes = shouldFetchSamples
    ? (querySamples as SearchGridData)?.map(sample => ({
        sha1: sample.sha1,
        available: sample.sample_available,
        location: sample.location
      }))
    : (querySamples as ExtractedFilesSample[])?.map(sample => ({
        sha1: sample.sha1,
        available: true,
        location: "local"
      }));

  const unsubscribeQueryHashes = querySamples?.map(sample => sample.sha1);

  return {
    subscribeQueryHashes,
    unsubscribeQueryHashes,
    shouldUseQueryHashes,
    isLoadingQueryHashes: isLoadingSamplesList
  };
};

export default useSelectAllQueryHashes;
